/**
 * @name 处理登陆身份鉴权
 * @author fansc
 * @time 2020.05.20
 */
import Vue from "vue";
import router from "../router";
// import { uasInit } from "../util/uas.js";
let HOSTS;
if (location.host.includes('bsrmprd')) { //生产环境-采购端-录入到《供应商关系管理系统》系统
  HOSTS = true;
} else if (location.host.includes('bsrmqas')) { //测试环境-录入到《供应商关系管理系统》系统
  HOSTS = true;
}else if (location.host.includes('bsrm.boe')) { //生产环境-供应商端-录入到《供应商一站式》系统
  HOSTS = false;
}
const uasUpdate = data => {
  try {
    // eslint-disable-next-line no-undef
    const uasInit = UAS({
      frameType: "vue",
      systemCode: HOSTS? "SYS00007": "SYS00580",
      systemName: HOSTS? "供应商关系管理系统" :"供应商一站式",
      getUserId: () => {
        return data.user_code ? data.user_code : data.els_subaccount;
      }
    });
    //  加入埋点系统
    Vue.use(uasInit, { router });
  } catch (e) {
    /* istanbul ignore next */
  }
};
export default uasUpdate;
